import { defineMessages } from 'react-intl';

export const profileMessages = defineMessages({
  accountSettings: {
    defaultMessage: 'Account Settings',
    description: `Short description for the link for managing an account`,
    id: 'uchi.usermenu.account-settings',
  },
  logout: {
    defaultMessage: 'Log out',
    description: 'Link that logs out the current user',
    id: 'uchi.usermenu.logout-link',
  },
  manageYourAccount: {
    defaultMessage: 'Manage your account',
    description: `Link to update settings for a user's account`,
    id: 'uchi.usermenu.manage-account',
  },
  profile: {
    defaultMessage: 'Profile',
    description: `Short description of the profile`,
    id: 'uchi.usermenu.profile',
  },
});
